import { View } from 'react-native';
import React from 'react';
import { Button } from '~/components';
import { twMerge } from 'tailwind-merge';

interface Props {
  isValid: boolean;
  className?: string;
  onSubmit: () => void;
}

const Footer = ({ isValid, className, onSubmit }: Props) => {
  return (
    <View className={twMerge('justify-end bg-white', className)}>
      <View className="w-[100%] h-[1px] bg-gray-100 lg:hidden" />

      <View className="px-6 py-4 pb-6">
        <Button disabled={!isValid} onPress={onSubmit}>
          Continuar
        </Button>
      </View>
    </View>
  );
};

export default Footer;
